import React from 'react';
import { Link } from 'react-router-dom';
import aboutContent from '../data/aboutContent';
import { getImagePath } from '../utils/imageOptimization';
import '../styles/about.css';

function About() {
  const featuredImagePath = getImagePath(aboutContent.featured_image, 'full', 'about');

  return (
    <main className="about-page">
      <div className="about-container">
        <div className="about-text">
          <div className="bio">
            {aboutContent.bio.split('\n\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          <div className="cta">
            <Link to="/" className="cta-link">View Gallery</Link>
            <Link to="/contact" className="cta-link">Get in Touch</Link>
          </div>
        </div>

        <div className="about-image">
          <img src={featuredImagePath} alt="Featured artwork" />
        </div>
      </div>
    </main>
  );
}

export default About;
